import { useState } from 'react';
import classnames from 'classnames'
import { tr } from 'react-hook-form-auto'

import {
  Button,
  Icon,
  Modal,
  ModalAutoform
} from '../../ui/bootstrap/bootstrap'
import GroupIngredientsContainer from './GroupIngredientsContainer'
import { IngredientGroup } from '../../models/ingredientGroup'

import styles from './GroupsView.sass'

const renderGroups = ({
  collection = [],
  showMore = {},
  onShowMore,
  onEditDoc,
  onDeleteDoc
}) =>
  collection.map(({ id, name }) => {
    const handleEdit = () => onEditDoc({ id, name })
    const handleDelete = () => onDeleteDoc({ id, name })

    return (
      <div key={id} className={styles.group}>
        <div className={classnames(styles.title, styles.bar)}>
          {name}
          <div className={styles.edit} onClick={handleEdit}>
            <Icon icon="bars" />
          </div>
          <div
            className={classnames(styles.edit, styles.delete)}
            onClick={handleDelete}
          >
            <Icon icon="trash" />
          </div>
        </div>
        <GroupIngredientsContainer
          groupId={id}
          long={showMore[id]}
          onShowMore={onShowMore}
        />
      </div>
    )
  })

const renderConfirmDelete = ({ doc, onConfirm, onClose }) => {
  const buttons = (
    <div>
      <Button
        text={tr('models.delete')}
        type="danger"
        iconClass="trash"
        onClick={onConfirm}
      />
      <Button
        text={tr('cancel')}
        onClick={onClose}
      />
    </div>
  )

  return (
    <Modal
      title={tr('warning')}
      visible={Boolean(doc)}
      onClose={onClose}
      buttons={buttons}
    >
      {tr('models.ingredient_groups.warnDelete', {
        name: doc && doc.name || ''
      })}
    </Modal>
  )
}

const renderForm = ({ editing, doc, onGroupUpdate, onClose }) => {
  if (editing) {
    return (
      <ModalAutoform
        onSubmit={onGroupUpdate}
        initialValues={doc}
        schema={IngredientGroup.schema}
        form="ingredientGroup"
        onClose={onClose}
        modalTitle={tr('models.groups')}
        visible={editing}
      />
    )
  } else
    return null
}

export const GroupsView = ({
  groupUpdate,
  collection,
  showMore,
  onShowMore,
  onGroupUpdate,
  onGroupDelete,
  ...rest
}) => {
  const [ editing, setEditing ] = useState(false)
  const [ editDoc, setEditDoc ] = useState({})
  const [ deleteDoc, setDeleteDoc ] = useState(null)

  const handleEditDoc = (doc = {}) => {
    setEditing(true)
    setEditDoc(doc)
  }

  const handleModalClose = () => {
    setEditing(false)
  }

  const handleDeleteDoc = doc => {
    setDeleteDoc(doc)
  }

  const handleDeleteClose = () => {
    setDeleteDoc(null)
  }

  const handleDeleteConfirm = () => {
    onGroupDelete(deleteDoc)
    setDeleteDoc(null)
  }

  const formProps = {
    editing,
    doc: editDoc,
    onGroupUpdate,
    onClose: handleModalClose
  }

  const renderGroupsProps = {
    collection,
    showMore,
    onShowMore,
    onGroupUpdate,
    onEditDoc: handleEditDoc,
    onDeleteDoc: handleDeleteDoc
  }

  const confirmDeleteProps = {
    doc: deleteDoc,
    onConfirm: handleDeleteConfirm,
    onClose: handleDeleteClose
  }

  return (
    <div>
      <div className={styles.groups}>
        <div key="add" className={styles.group}>
          <a
            className={classnames(styles.add, styles.bar)}
            onClick={handleEditDoc.bind(null, {})}
          >
            <Icon icon="plus" text={tr('add')} />
          </a>
        </div>
        {renderGroups(renderGroupsProps)}
      </div>
      {renderForm(formProps)}
      {renderConfirmDelete(confirmDeleteProps)}
    </div>
  )
}
